<template>
	<div>
		<!-- <MyBread v-bind:BreadcrumbList="BreadcrumbList"></MyBread> -->
		<Form ref="formInline" :model="formInline" inline style="text-align: left;margin-top: 1%;">
			<FormItem prop="trackName" :label="$tt('运营商:')" :label-width="80">
				<Select filterable clearable style="width: 120px;" v-model="formInline.OperatorId">
					<Option v-bind:key="item.Id" v-for="(item) in OperatorList" :value="item.Id">{{item.Name}}</Option>
				</Select>
			</FormItem>
			<FormItem prop="trackName" :label="$tt('充电站')" :label-width="65">
				<Select filterable :placeholder="$tt('站点列表')" style="width: 120px;" v-model="formInline.StationId">
					<Option :value=0>{{$tt('全部')}}</Option>
					<Option v-bind:key="item.StationId" v-for="(item) in StationList" :value="item.StationId">{{item.StationName}}</Option>
				</Select>
			</FormItem>
			<FormItem>
				<Input type="text" v-model="formInline.EquipmentNo" style="width: 180px;" :placeholder="$tt('设备编号')">
				<span slot="prepend">{{$tt('设备编号')}}</span>
				</Input>
			</FormItem>
			<FormItem prop="trackName">
				<Input type="text" v-model="formInline.EquipmentSerialNo" style="width: 180px;" :placeholder="$tt('设备序列号')">
				<span slot="prepend">{{$tt('设备序列号')}}</span>
				</Input>
			</FormItem>
			<FormItem>
				<Button type="primary" @click="handleSubmit('formInline')" v-if="hasWidgets('search')">{{$tt('查询')}}</Button>
			</FormItem>
		</Form>
		<PageTable ref="tableInst" :columns="columns1" :tableHeight="tableHeight" :url="getEquipEventsUrl" :queryParam="pageParam"></PageTable>
		<!-- <echartModal ref="echartModal" curvesName="ChargeRecord"></echartModal> -->
		<Modal :mask-closable="false" v-model="modalView" :title="modal.Title" width="80%" height="80%">
			<Input v-model="datagramDesc" type="textarea" :readonly="true" :autosize="true" placeholder=""></Input>
		</Modal>
	</div>
</template>

<script>
	import dateFormat from '@/../public/js/comm.js'
	import PageTable from '@/components/public/PageTable/PageTable.vue';
	import expandRow from './EquipNetworkEventsExpand.vue';
	import {
		mapState,
		// mapGetters,
		// mapActions
	} from 'vuex'
	import webapi from '@/webapi.js'
	export default {
		components: {
			PageTable,
			expandRow
		},
		data() {
			return {
				getEquipEventsUrl: webapi.base_api_url + '/Events/GetEquipEvents',
				loadingStatus: false,
				//model表单
				params: "", //table 传参
				//选择展示的充电站
				SelectStation: "",
				tableHeight: "650",
				modal: {
					Title: this.$tt('报文分析'),
					type: "addDevice"
				},
				modalView: false,
				datagramDesc: '',
				formInline: {
					StationId: 0,
					EquipmentNo: '',
					EquipmentSerailNo: '',
				},
				//table标题数据
				columns1: [
					{
						type: 'expand',
						width: 50,
						render: (h, params) => {
							return h(expandRow, {
								props: {
									row: params.row
								}
							})
						}
					},
					{
						title: this.$tt('序号'),
						type: 'index',
						width: 60
					},
					{
						title: this.$tt('枪编号'),
						key: 'EquipmentNo',
						width: 110
					},
					{
						title: this.$tt('设备序列号'),
						key: 'EquipmentSerialNo',
						width: 110
					},
					{
						title: this.$tt('站点名称'),
						key: 'StationName',
						minWidth: 100,
					},
					{
						title: this.$tt('原始报文'),
						key: 'Datagram',
						minWidth: 200,
						ellipsis: true,
					},
					{
						title: this.$tt('操作'),
						key: 'action',
						align: 'center',
						width: 100,
						render: (h, params) => {
							return h('div', [
								this.hasWidgets('analyzeDatagram') ? h('Button', {
									props: {
										type: 'primary',
										size: 'small'
									},
									style: {
										marginRight: '5px'
									},
									on: {
										click: () => {
											this.analyzeDatagram("view", params.row.Datagram)
										}
									}
								}, this.$tt('分析报文')) : h(),
							]);
						}
					}
				],
				data1: [],
			};
		},
		created() {
			const _this = this;
			// _this.tableHeight = window.innerHeight - 160;
			_this.getTableHeight();
			window.addEventListener('resize', this.getTableHeight)
		},
		destroyed() {
			window.removeEventListener("resize", this.getTableHeight);
		},
		mounted() {
			//this.handleSubmit();
		},
		computed: {
			pageParam: function() {
				const _this = this;
				let param = _this.formInline;
				return param;
			},
			//直接选属性
			...mapState({
				StationList: 'Stations',
				OperatorList: 'typeList',
			})
		},
		watch: {},
		methods: {
			hasWidgets: function(widgetName) {
				return this.$route.meta.widgets.find(w => w.Name == widgetName);
			},
			rowClassName: function(row, index) {
				if (index % 2 == 0) {
					return 'demo-table-info-row';
				} else if (index % 2 == 1) {
					return 'demo-table-error-row';
				}
				return '';
			},
			//操作
			// show: function(type, params) {
			// 	const _this = this
			// 	switch (type) {
			// 		case "view":
			// 			_this.$refs.echartModal.show(type, params)
			// 			break;
			// 		default:
			// 			break;
			// 	}
			// },
			analyzeDatagram: function(type, params) {
				if (!params) return;
				const _this = this;
				_this.$axios.post('https://demo.sdxny.cn/protocol/analyze', { data: params }).then(res => {
					this.datagramDesc = res.data.data;
					this.modalView = true;
				}).catch(err => {
					
				});
			},
			//Page组件回调
			getDeviceData: function(data) {
				console.log(data)
				this.data1 = data.Data.List
			},
			handleSubmit: function() {
				if (!this.hasWidgets('search')) return;
				// this.$refs.sonPage.getList();
				this.$refs.tableInst.getData();
			},
			getTableHeight: function() {
				this.tableHeight = window.innerHeight - 160 - (window.innerWidth < 1654 ? 40 : 0);
			}
		},
	}
</script>

<style>
</style>